import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/baskets/')({
  beforeLoad: () => {
    throw redirect({ to: '/orders' })
  },
})
